import { ROLES } from 'utils/roles';

// Single source of truth for "where does this user belong after logging in".
// Both the auth views (login / register / social / 2FA) and the authenticated
// guard in views/Home/platform.js resolve the destination through this helper so
// a role never lands on the wrong view depending on which path got there first.
export const DEFAULT_ROLE_PATH = '/my-courses';

export const getRoleRedirectPath = (viewer) => {
  if (!viewer) return DEFAULT_ROLE_PATH;

  const { is_superadmin, role_id, image, profile_image_link } = viewer;

  // Institutional roles need a completed profile before reaching their course
  // list, otherwise the list renders without the data it reads from the viewer.
  const hasProfileImage = Boolean(image || profile_image_link);

  switch (role_id) {
    case ROLES.basic:
      return DEFAULT_ROLE_PATH;

    case ROLES.university:
      return hasProfileImage ? '/search/courses/university' : '/profile';

    case ROLES.faculty:
    case ROLES.career: {
      if (!hasProfileImage) return '/profile';
      const rolePath = role_id === ROLES.career ? 'career' : 'faculty';
      return `/search/courses/${rolePath}`;
    }

    default:
      if (is_superadmin || role_id === ROLES.superadmin) return '/superadmin';
      return DEFAULT_ROLE_PATH;
  }
};
